import React, { useState, useEffect } from "react";
import { FaEdit, FaEye, FaPlus, FaMinus } from "react-icons/fa";
import { FundEditModal } from "../modals/FundEditModal";
import axios from "axios";
import {
  calculateTotalFloat,
  formatRupees,
  roundNumber,
} from "../../../../utils/inputsValidation";
import { ActionFormModal } from "../modals/ActionFormModal";
import { IoInformationCircleOutline } from "react-icons/io5";

import FundDetailsModal from "../FundDetailsModal";
import api from "../../../../utils/api";
import Swal from "sweetalert2";
import moment from "moment";
import socket from "../../../../context/socket";
import parse, { domToReact } from "html-react-parser";
import { filter } from "lodash";

export default function HierarchicalTable({
  userData,
  isPortfolioData,
  fetchPortfolioData,
  onlyone,
  effectiveValue,
  isChecked,
  setIsChecked,
  rowActions,
  setRowActions,
  schemeCode,
  setSchemeCode,
  allowedReview,
}) {
  // console.log('grandTotalVal', grandTotalVal, allowedReview, isPortfolioData);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showActionModal, setShowActionModal] = useState(false);
  const [showActionFormModal, setShowActionFormModal] = useState(false);
  const [prRowId, setPrRowId] = useState("");

  const [openSipFormAllData, setOpenSipFormAllData] = useState({});
  console.log("openSipFormAllData", openSipFormAllData);

  const [subRowExpandedMobile, setSubRowExpandedMobile] = useState({});
  const [tableExpanded, setTableExpanded] = useState({});

  const [isActionMessage, setIsActionMessage] = useState("");
  const [amcName, setAmcFundList] = useState([]);

  const [currentRowKey, setCurrentRowKey] = useState(null);

  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedGoalDetail, setSelectedGoalDetail] = useState({});
  const [selectedClientreviewedfolio, setSelectedClientreviewedfolio] =
    useState({});

  const [expandedRowKey, setExpandedRowKey] = useState(null);
  const [loadingRowKey, setLoadingRowKey] = useState(null);
  const [folioData, setFolioData] = useState({});

  const [editRowData, setEditRowData] = useState({});
  const [subRowExpanded, setSubRowExpanded] = useState({});
  const [modalContent, setModalContent] = useState("");
  const [viewPrErrors, setViewPrErrors] = useState([]);

  const [openFunds, setOpenFunds] = useState({});

  const toggleFund = (fundKey) => {
    setOpenFunds((prev) => ({
      ...prev,
      [fundKey]: !prev[fundKey],
    }));
  };
  const [openTransactions, setOpenTransactions] = useState({});

  const toggleTransaction = (fundKey) => {
    setOpenTransactions((prev) => ({
      ...prev,
      [fundKey]: !prev[fundKey],
    }));
  };

  const handleToggle = () => {
    setIsChecked((prev) => !prev); // Toggle state
  };
  const goalGoalData = isPortfolioData?.folioGoalData
    ? Object.entries(isPortfolioData?.folioGoalData)
      .filter(([key, value]) => value.goalName)
      .map(([key, value]) => ({
        key,
        goalName: value.goalName,
        goalId: value.goalId,
        subId: value.subId,
        aum: value.aum,
        client_id: value.client_id,
        runningSIP: value.runningSIP,
        startYear: value.startYear,
        goalYear: value.goalYear,
      }))
    : [];
  // console.log("isPortfolioData", isPortfolioData,schemeCode,prRowId);
  // console.log("userData65", isPortfolioData?.folioGoalData);

  const handleEditClick = async (
    subRowFolio,
    subRowISIN,
    fund,
    allSameFunds,
    rowData,
    rowData2,
  ) => {
    console.log('allSameFunds1', allSameFunds);
    // const rowKey = `${rowData2.folio}_${rowData2.ISIN}`;
    const rowKey = `${subRowFolio}_${subRowISIN}`;

    setCurrentRowKey(rowKey);

    try {
      // Set the row data for editing
      setEditRowData(rowData2);

      // Fetch goal details and client reviewed folio details
      const goalDetail = await getGoalDetail(subRowFolio, subRowISIN);
      const clientReviewedFolio = await getClientreviewedfolio(
        subRowFolio,
        subRowISIN,
      );


      // console.log('goalDetail89', goalDetail)
      // console.log("subRowFolio", subRowFolio, subRowISIN, goalDetail, fund, clientReviewedFolio);
      const issip = clientReviewedFolio?.portfolio_type_sip || 0;
      const currentValue = fund?.MarketValue;

      // console.log("goalDetail",clientReviewedFolio,goalDetail,issip,currentValue);
      // Initialize variables with default values
      let goalName = "Unmapped";
      let goalId = "";
      let subId = "";
      let runningSIP = 0;
      let requiredSIP = 0;
      let expectedReturn = 0;
      let targetYear = 0;
      let startYear = 0;
      let targetAmount = 0;
      let aum = 0;
      if (goalDetail) {
        goalName = goalDetail.goalName || goalName;
        goalId = goalDetail.goalId || goalId;
        subId = goalDetail?.subId || subId;
        runningSIP = goalDetail.runningSIP || runningSIP;
        targetAmount = goalDetail.targetAmount || targetAmount;
        aum = goalDetail?.aum || 0;
        startYear = goalDetail?.startYear || startYear;
        targetYear = goalDetail?.goalYear || targetYear;
      }

      // console.log('tt',{
      //   goalName,
      //   goalId,
      //   runningSIP,
      //   requiredSIP,
      //   expectedReturn,
      //   targetYear,
      //   startYear,
      //   targetAmount,
      //   aum,
      //   issip,

      // });

      // // Open SIP form with the gathered data
      opensipform(
        fund?.scheme_code,
        fund?.pan_client_id,
        fund?.FundName,
        subRowISIN,
        subRowFolio,
        issip,
        currentValue,
        goalName,
        goalId,
        subId,
        runningSIP,
        aum,
        requiredSIP,
        expectedReturn,
        targetYear,
        startYear,
        targetAmount,
        fund,
        allSameFunds,
      );

      // Show the edit modal
      setShowEditModal(true);
    } catch (error) {
      console.error("Error handling edit click:", error);
    }
  };

  async function opensipform(
    scheme_code,
    pan_client_id,
    schemename,
    ISIN,
    portfolioid,
    isSIP,
    currentval,
    goalName,
    goalId,
    subId,
    runningSIP,
    aum,
    requiredSIP,
    cagr,
    goalYear,
    startYear,
    targetAmount,
    fund,
    allSameFunds,
  ) {
    const allData = {
      scheme_code: scheme_code,
      pan_client_id: pan_client_id,
      clientid: roomId,
      currentval: currentval,
      schemename: schemename,
      portfolioid: portfolioid,
      ISIN: ISIN,
      isSIP: isSIP,
      moneyformatecurval: currentval,
      goalName: goalName,
      goalId: goalId,
      subId: subId,
      goalsOption: isPortfolioData?.options?.options,
      runningSIP: runningSIP,
      aum: aum,
      requiredSIP: requiredSIP,
      cagr: cagr,
      goalYear: goalYear,
      startYear: startYear,
      targetAmount: targetAmount,
      fund: fund,
      allSameFunds: allSameFunds,
    };
    // console.log("allDataq", allData);
    setOpenSipFormAllData(allData);
  }

  const toggleRow = (key) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [key]: !prevExpandedRows[key],
    }));
  };

  const fetchViewPrErrors = async (prRowId) => {
    try {
      // Swal.fire({
      //   text: "Please wait...",
      //   imageUrl: 'https://www.finedge.in/assets/images/download.gif',
      //   showConfirmButton: false,
      //   allowOutsideClick: false,
      //   allowEscapeKey: false,
      // });

      const allData = {
        clientid: roomId,
        pr_row_id: prRowId,
      };
      // API Call
      const response = await api.post(`advisor/view_pr_errors`, allData);
      //   console.log("view_pr_errors res",response.data);
      setViewPrErrors(response.data.data);
      setPrRowId(prRowId);
    } catch (error) {
      console.error("Error fetching portfolio data:", error);
      // Swal.fire({
      //   icon: 'error',
      //   title: 'Oops...',
      //   text: 'Failed to load portfolio data. Please try again later.',
      // });
    } finally {
      // Swal.close(); // Ensure the alert closes in both success and error cases
      setShowActionFormModal(true);
    }
  };

  const toggleSubRow = (key) => {
    setSubRowExpanded((prevSubRowExpanded) => ({
      ...prevSubRowExpanded,
      [key]: !prevSubRowExpanded[key],
    }));
  };

  const getGoalDetail = (folio, ISIN) => {
    // console.log('goalGoalData8', goalGoalData)
    const key = `${folio}${ISIN}`;
    const matchedEntry = goalGoalData.find((entry) => entry.key === key);
    console.log("matchedEntry", matchedEntry, key);
    return matchedEntry || {};
  };

  const getAMCFundList = async () => {
    if (amcName.length > 0) return; // Avoid re-calling if already fetched
    // setIsLoadingAMC(true);
    try {
      const response = await api.get(`advisor/master_amc_fund_list`);
      setAmcFundList(response.data || []);
    } catch (error) {
      console.error("Error fetching AMC fund list:", error);
    } finally {
      // setIsLoadingAMC(false);
    }
  };

  useEffect(() => {
    // if (showEditModal) {
    getAMCFundList();
    // }
  }, []);

  // const showFundDetails = async (
  //   schemeCodeData,
  //   clientreviewedfolioData,
  //   rowData2,
  //   schemeCode,
  //   goalName,
  //   goalYear,
  //   fundName,
  //   startYear = new Date().getFullYear()
  // ) => {
  //   // console.log(
  //   //   "schemeCodeData",
  //   //   schemeCodeData,
  //   //   clientreviewedfolioData,
  //   //   goalName,
  //   //   rowData2
  //   // );

  //   const goalDetail = getGoalDetail(rowData2?.folio, rowData2?.ISIN);
  //   const preGoalDetails = isPortfolioData?.goaldeatils[goalDetail?.goalId];
  //   // console.log("schemeCodeData",goalDetail,preGoalDetails);
  //   setShowActionModal(true);
  //   // setModalContent(`<p style="text-align:center;">Loading... <br><img src="/assets/images/download.gif" width="100"/></p>`);

  //   try {
  //     // console.log("fgs", schemeCodeData,clientreviewedfolioData?.stp_fundname)

  //     const params = new URLSearchParams();
  //     params.append("schemeCode", schemeCodeData);

  //     let res;

  //     // ✅ If schemeCodeData is empty or undefined, use get_fund_by_name with JSON body
  //     res = await api.post(
  //       `advisor/get_fund_by_name`,
  //       {
  //         fund_name: clientreviewedfolioData?.stp_fundname,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     const data = await res.data;

  //     if (!data || data.length === 0) return;

  //     const fund = data;
  //     // console.log("response 12", fund);

  //     if (
  //       fund.Whitelisted !== "true" ||
  //       fund.Time_Horizon === "Temporary Parking"
  //     ) {
  //       const errorMsg =
  //         fund.Whitelisted === "false"
  //           ? "Fund snapshots are only available for whitelisted funds"
  //           : "Fund Snapshots not available for Temporary Parking Funds";
  //       setModalContent(
  //         `<p class="text-danger text-center mt-3">${errorMsg}</p>`
  //       );
  //       return;
  //     }

  //     const currentYear = new Date().getFullYear();
  //     const goalDuration = preGoalDetails?.goalYear - preGoalDetails?.startYear;
  //     let rtn2 =
  //       goalDuration <= 1
  //         ? "5 %"
  //         : goalDuration <= 3
  //           ? "8 %"
  //           : goalDuration <= 4.99
  //             ? "10 %"
  //             : goalDuration <= 6.99
  //               ? "12 %"
  //               : "13 %";

  //     let stmt2 = "";
  //     let rtnText = "";
  //     switch (fund.Time_Horizon) {
  //       case "1-3 Years":
  //         rtnText = "3 YEAR RETURN";
  //         stmt2 = "Short term focus is capital protection.";
  //         break;
  //       case "3-5 Years":
  //         rtnText = "5 YEAR RETURN";
  //         stmt2 = "Staggered entries work well here.";
  //         break;
  //       case "Above 5 Years":
  //         rtnText = "10 YEAR RETURN";
  //         stmt2 = "Invest monthly through SIPs or STPs.";
  //         break;
  //     }

  //     let SIRtn = fund.return_since_inception?.trim() || "Unavailable";

  //     if (!goalName?.toLowerCase().includes("goal")) goalName += " Goal";
  //     const goalName2 = ["marriage", "graduation"].some((g) =>
  //       clientreviewedfolioData.goal_name?.toLowerCase().includes(g)
  //     )
  //       ? clientreviewedfolioData.goal_name
  //       : "Your " + clientreviewedfolioData.goal_name;

  //     let riskProfile = fund.Risk_Profile?.replace(" Funds", "") || "";
  //     riskProfile = (riskProfile === "Aggressive" ? "an " : "a ") + riskProfile;

  //     const html = `
  //       <div style="max-height: 600px; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;">
  //         <div class="row">
  //           <div class="col-sm-2 text-center"><img src="/assets/images/fund-scheme.png" style="width: 6vw;"></div>
  //           <div class="col-sm-8 text-dark pt-3 text-center">
  //             <div style="font-size:1.7vw;"><strong>${clientreviewedfolioData.goal_name
  //       } | Year ${preGoalDetails?.goalYear}</strong></div>
  //             <div style="font-size: 1.3vw;">${fund.fund_name}</div>
  //           </div>
  //         </div><br>
  //         <div class="row text-center mb-3">
  //           <div class="col-sm-4 text-dark"><strong>FUND SIZE</strong><br><span class="text-success fs-5 fw-bold">${fund.fund_size
  //       }</span></div>
  //           <div class="col-sm-4 text-dark"><strong>INVESTMENT HORIZON</strong><br><span class="text-success fs-5 fw-bold">${fund.investment_horizon
  //       }</span></div>
  //           <div class="col-sm-4 text-dark"><strong>RETURN SINCE INCEPTION</strong><br><span class="text-success fs-5 fw-bold">${SIRtn}</span></div>
  //         </div>
  //         <div class="row d-flex justify-content-between text-center mb-3">
  //           <div class="col-sm-4 text-dark"><strong>CATEGORY</strong><br><span class="text-success fs-5 fw-bold">${fund.Sub_Category
  //       }</span></div>
  //           <div class="col-sm-4 text-dark"><strong>RETURN REQUIRED TO ACHIEVE GOAL</strong><br><span class="text-success fs-5 fw-bold">${rtn2}</span></div>
  //         </div>
  //         <hr>
  //         <div class="row">
  //           <div class="col-sm-8">
  //             <div style="background: #fff1e8;border: .7vw solid #ffd1d1;min-height: 13vw;">
  //               <span class="fs-5 fw-bold text-success">RECOMMENDATION RATIONALE</span>
  //               <ul class="small mt-2 ms-3 text-justify">
  //                 ${[
  //         fund.rationale1,
  //         fund.rationale2,
  //         fund.rationale3,
  //         fund.rationale4,
  //         fund.rationale5,
  //       ]
  //         .map((r) => `<li>${r}</li>`)
  //         .join("")}
  //               </ul>
  //             </div>
  //           </div>
  //           <div class="col-sm-4">
  //             <span class="fs-5 fw-bold text-success">SUMMARY</span>
  //             <img src="/assets/images/fund_scheme_bulb.png" style="width: 3.5vw;">
  //             <hr>
  //             <p style="font-size: 1vw;">${goalName2} is ${preGoalDetails?.goalYear - currentYear
  //       } years away. We recommend ${riskProfile} fund like ${fundName}. ${stmt2}</p>
  //           </div>
  //         </div>
  //         <div>
  //         <span class="fs-5 fw-bold text-success">OUR PHILOSOPHY</span>
  //         <ul class="small mt-2 ms-3 text-justify text-dark">
  //                 ${[
  //         fund.philosophy1,
  //         fund.philosophy2,
  //         fund.philosophy3,
  //         fund.philosophy4,
  //         fund.philosophy5,
  //       ]
  //         .map((r) => `<li>${r}</li>`)
  //         .join("")}
  //               </ul>
  //         </div>
  //       </div>
  //     `;

  //     setModalContent(html);
  //   } catch (err) {
  //     console.error(err);
  //     setModalContent(
  //       `<p class="text-danger text-center mt-3">Something went wrong</p>`
  //     );
  //   }
  // };

  // console.log("actionNamedfgdfg", actionName)

  const [showModal, setShowModal] = useState(false);

  const getClientreviewedfolio = (folio, ISIN) => {
    // console.log(" Folio:",folio, ISIN, isPortfolioData);
    const clientreviewedfolio = isPortfolioData?.clientreviewedfolio;
    if (!clientreviewedfolio || !Array.isArray(clientreviewedfolio)) {
      console.error("Client folio data is not available or not an array.");
      return null;
    }

    // Finding the matching object
    const matchingFolio = clientreviewedfolio.find(
      (clientFolio) =>
        clientFolio.portfolio_id === folio &&
        clientFolio.portfolio_ISIN === ISIN,
    );

    if (matchingFolio) {
      // console.log("Matching Folio:", matchingFolio);
      return matchingFolio;
    } else {
      return null;
    }
  };

  useEffect(() => {
    // Automatically expand all rows on load

    const initialExpandedRows = {};
    // userData?.forEach((item, index) => {
    //   const mainKey = `0-${index}`;
    //   initialExpandedRows[mainKey] = true;

    //   if (item.Detail) {
    //     item.Detail.forEach((subItem, subIndex) => {
    //       const subKey = `0-${index}-sub-${subIndex}`;
    //       initialExpandedRows[subKey] = false; // Initially, sub-items are collapsed
    //     });
    //   }
    // });

    setExpandedRows(initialExpandedRows);
  }, [userData]);

  function calculateEffectiveBalance(transactions, fundnametype, fundSubName) {
    let effiBal = 0;
    let fromDate = new Date();
    // console.log('transactions', fundnametype, transactions, fundSubName);

    // 🧠 Apply fund type rules to determine cutoff date
    if (
      (fundnametype === "Equity" && fundSubName !== "Equity - ELSS") ||
      (fundnametype === "Hybrid" && fundSubName !== "Hybrid - Arbitrage")
    ) {
      fromDate.setMonth(fromDate.getMonth() - 12); // 12 months ago
    } else if (
      fundnametype === "Debt" ||
      fundnametype === "Hybrid - Arbitrage" ||
      fundnametype === "Others"
    ) {
      // keep current date (no backdate)
    } else {
      fromDate.setMonth(fromDate.getMonth() - 36); // 36 months ago
    }

    // ✅ Allow flexible transaction type matching
    const validTypes = [
      "SIP Purchase",
      "Purchase",
      "STP In",
      "STP In Installment No",
      "Switch In",
    ];

    (transactions || []).forEach((tx) => {
      const rawDate = tx.TransactionDate;
      if (!rawDate) return;

      // Handle DD/MM/YYYY or DD-MM-YYYY
      const parts = rawDate.includes("/")
        ? rawDate.split("/")
        : rawDate.split("-");
      if (parts.length !== 3) return;

      let [dd, mm, yy] = parts;

      // Normalize year
      if (yy.length === 2) yy = `20${yy}`;
      if (mm.length === 1) mm = `0${mm}`;
      if (dd.length === 1) dd = `0${dd}`;

      const txDate = new Date(`${yy}-${mm}-${dd}`);

      const isValidType = validTypes.some((type) =>
        tx.Description?.startsWith(type),
      );

      if (!isNaN(txDate) && isValidType && txDate < fromDate) {
        effiBal += parseFloat(tx.curr_val) || 0;
      }
    });

    return effiBal;
  }

  const calculateEffiBalTotal = (val) => {
    let total = 0;

    userData?.forEach((user) => {
      const portfoioData = user?.Portfoio ? Object.values(user?.Portfoio) : [];

      portfoioData?.forEach((item) => {
        item?.Detail?.forEach((subFund) => {
          subFund?.Detail?.forEach((subFundDetail) => {
            const txns = subFundDetail?.Transaction || [];
            const fundnametype = item["Fund Name"];
            const fundSubName = subFund["Fund Sub Name"];
            let fromDate = new Date();

            if (
              (fundnametype === "Equity" && fundSubName !== "Equity - ELSS") ||
              (fundnametype === "Hybrid" &&
                fundSubName !== "Hybrid - Arbitrage")
            ) {
              fromDate.setMonth(fromDate.getMonth() - 12);
            } else if (
              fundnametype === "Debt" ||
              fundnametype === "Hybrid - Arbitrage" ||
              fundnametype === "Others"
            ) {
              // keep current
            } else {
              fromDate.setMonth(fromDate.getMonth() - 36);
            }

            const validTypes = [
              "SIP Purchase",
              "Purchase",
              "STP In",
              "Switch In",
            ];

            txns.forEach((tx) => {
              const parts =
                tx["Transaction Date"]?.replace(/-/g, "/")?.split("/") || [];

              if (parts.length === 3) {
                let [dd, mm, yy] = parts;
                if (yy.length === 2) yy = "20" + yy;
                const txDate = new Date(`${yy}-${mm}-${dd}`);

                if (
                  !isNaN(txDate) &&
                  validTypes.includes(tx["Transaction Type"]) &&
                  txDate < fromDate
                ) {
                  total += parseFloat(tx["Current Value"] || 0);
                }
              }
            });
          });
        });
      });
    });

    return Number(total.toFixed(2));
  };

  // Top of component
  const [expandedSubKey, setExpandedSubKey] = React.useState(null);

  // const handleEyeClick = (subKey, e) => {
  //   e?.stopPropagation?.(); // row click se conflict avoid
  //   setExpandedSubKey((prev) => (prev === subKey ? null : subKey));
  // };

  const handleEyeClick = async (fundId, folioId, subKey, e) => {
    e.stopPropagation();

    // ✅ Generate unique key from fundId + folioId
    const key = subKey;

    // ✅ Collapse if already expanded
    if (expandedRowKey === key) {
      setExpandedRowKey(null);
      return;
    }

    // ✅ Show cached data instantly
    if (folioData[key]) {
      setExpandedRowKey(key);
      return;
    }

    // ✅ Start loader
    setExpandedRowKey(key);
    setLoadingRowKey(key);

    try {
      const payload = { FundId: fundId, FolioID: folioId };
      const response = await api.post("advisor/getTransectionWM", payload);
      const data = response?.data || {};
      const transactions = Array.isArray(data.transactions)
        ? data.transactions
        : [];
      const transactionTotal = data.transactionTotal || null;

      setFolioData((prev) => ({
        ...prev,
        [key]: { transactions, transactionTotal },
      }));
    } catch (error) {
      console.error("❌ Error fetching transaction data:", error);
    } finally {
      setLoadingRowKey(null);
    }
  };

  // Inside your component mapping:
  const renderRecommendedAction = (htmlString, rowId, fund) => {
    console.log("fund-0", fund);

    const options = {
      replace: (domNode) => {
        // Check if the current element is the <i> tag (the info icon)
        if (domNode.name === "i" && domNode.attribs?.onclick) {
          // Extract arguments from the onclick string: showFundDetails('code', 'goal'...)
          // This regex captures everything inside the parentheses
          const match = domNode.attribs.onclick.match(/\((.*?)\)/);

          const args = match
            ? match[1].split(",").map((arg) => arg.trim().replace(/['"]/g, ""))
            : [];

          const fundName = args[3];
          const goalName = args[1];
          const goalYear = args[2];
          const startyear = new Date()
          const schemeCode = args[0];

          console.log("match-", fundName, goalName, goalYear, startyear, args);

          return (
            <span
              className="clrgreen ms-1"
              style={{ cursor: "pointer", display: "inline-block" }}
            >
              <IoInformationCircleOutline
                className="ms-1"
                style={{ fontSize: "1.2em", verticalAlign: "middle" }}
                onClick={(e) => {
                  e.stopPropagation();
                  // Pass the extracted arguments to your React function
                  showFundDetails(fundName, goalName, goalYear, startyear, schemeCode);
                }}
              />
            </span>
          );
        }
      },
    };

    return (
      <div
        onClick={() => fetchViewPrErrors(rowId)}
        style={{ cursor: "pointer" }}
      >
        {parse(htmlString, options)}
      </div>
    );
  };

  const showFundDetails = async (
    fundName,
    goalName,
    goalYear,
    startyear = new Date(),
    schemeCode,
  ) => {
    console.log("folio", schemeCode);

    // let goalYear = folio?.goal_folio_trans?.goalYear || "";



    setShowModal(true);

    setModalContent(`
    <div class="text-center py-5">
      <div class="spinner-border text-success" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2 text-muted">Fetching fund snapshots...</p>
    </div>
  `);
    try {
      socket.emit("show_snapshort", {
        room: roomId,
        show: true,
        data: {
          fundName,
          goalName,
          goalYear,
          startyear,
          schemeCode,
        },
      });
      console.log("Emitted show_fund_details:", {
        fundName,
        goalName,
        goalYear,
        startyear,
      });
      const res = await api.post(
        `advisor/get_fund_by_name`,
        {
          // fund_name: fundName,
          scheme_code: schemeCode,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const data = await res.data;
      if (!data || data.length === 0) {
        setModalContent(`<p class="text-warning text-center mt-3">No data found for this fund.</p>`);
        return;
      }
      if (!data || data.length === 0) return;

      const fund = data;
      console.log(" andfundName ", fund, fundName, goalName);

      if (
        fund.Whitelisted !== "true" ||
        fund.Time_Horizon === "Temporary Parking"
      ) {
        const errorMsg =
          fund.Whitelisted === "false"
            ? "Fund snapshots are only available for whitelisted funds"
            : "Fund Snapshots not available for Temporary Parking Funds";
        setModalContent(
          `<p class="text-danger text-center mt-3">${errorMsg}</p>`,
        );
        return;
      }

      const currentYear = new Date().getFullYear();
      const goalDuration = goalYear - moment(startyear).format("YYYY");

      let rtn2 =
        goalDuration <= 1
          ? "5 %"
          : goalDuration <= 3
            ? "8 %"
            : goalDuration <= 4.99
              ? "10 %"
              : goalDuration <= 6.99
                ? "12 %"
                : "13 %";
      console.log(
        "goalDuration",
        goalDuration,
        "goalYear",
        goalYear,
        "startyear",
        moment(startyear).format("YYYY"),
      );

      let stmt2 = "";
      let rtnText = "";
      switch (fund.Time_Horizon) {
        case "1-3 Years":
          rtnText = "3 YEAR RETURN";
          stmt2 = "Short term focus is capital protection.";
          break;
        case "3-5 Years":
          rtnText = "5 YEAR RETURN";
          stmt2 = "Staggered entries work well here.";
          break;
        case "Above 5 Years":
          rtnText = "10 YEAR RETURN";
          stmt2 = "Invest monthly through SIPs or STPs.";
          break;
      }

      let SIRtn = fund.return_since_inception?.trim() || "Unavailable";

      if (!goalName?.toLowerCase().includes("goal")) goalName += " Goal";
      console.log("response 12 h", fund);

      const goalName2 = ["marriage", "graduation"].some((g) =>
        goalName?.toLowerCase().includes(g) ? goalName : "Your " + goalName,
      );
      console.log("response goalName2 12 ", goalName2);

      let riskProfile = fund.Risk_Profile?.replace(" Funds", "") || "";
      riskProfile = (riskProfile === "Aggressive" ? "an " : "a ") + riskProfile;

      // const html = `
      //           <div style="max-height: 800px; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;">
      //             <div class="row">
      //               <div class="col-sm-2 text-center"><img src="/assets/images/fund-scheme.png" style="width: 6vw;"></div>
      //               <div class="col-sm-8 text-dark pt-3 text-center">
      //                 <div style="font-size:1.7vw;"><strong>${goalName} | Year ${goalYear || currentYear
      //   }</strong></div>
      //                 <div style="font-size: 1.3vw;">${fund.fund_name}</div>
      //               </div>
      //             </div><br>
      //             <div class="row text-center mb-3">
      //               <div class="col-sm-4 text-dark"><strong>FUND SIZE</strong><br><span class="text-success fs-5 fw-bold">${fund.fund_size
      //   }</span></div>
      //               <div class="col-sm-4 text-dark"><strong>INVESTMENT HORIZON</strong><br><span class="text-success fs-5 fw-bold">${fund.investment_horizon
      //   }</span></div>
      //               <div class="col-sm-4 text-dark"><strong>RETURN SINCE INCEPTION</strong><br><span class="text-success fs-5 fw-bold">${SIRtn}</span></div>
      //             </div>
      //             <div class="row d-flex justify-content-between text-center mb-3">
      //               <div class="col-sm-4 text-dark"><strong>CATEGORY</strong><br><span class="text-success fs-5 fw-bold">${fund.Sub_Category
      //   }</span></div>
      //               <div class="col-sm-4 text-dark"><strong>RETURN REQUIRED TO ACHIEVE GOAL</strong><br><span class="text-success fs-5 fw-bold">${rtn2}</span></div>
      //             </div>
      //             <hr>
      //             <div class="row">
      //               <div class="col-sm-8">
      //                 <div style="background: #fff1e8;border: .7vw solid #ffd1d1;min-height: 13vw;">
      //                   <span class="fs-5 fw-bold text-success">RECOMMENDATION RATIONALE</span>
      //                   <ul class="small mt-2 ms-3 text-justify">
      //                     ${[
      //     fund.rationale1,
      //     fund.rationale2,
      //     fund.rationale3,
      //     fund.rationale4,
      //     fund.rationale5,
      //   ]
      //     .map((r) => `<li>${r}</li>`)
      //     .join("")}
      //                   </ul>
      //                 </div>
      //               </div>
      //               <div class="col-sm-4">
      //                 <span class="fs-5 fw-bold text-success">SUMMARY</span>
      //                 <img src="/assets/images/fund_scheme_bulb.png" style="width: 3.5vw;">
      //                 <hr>
      //                 <p style="font-size: 1vw;">${goalName} is ${(goalYear || currentYear) - currentYear
      //   } years away. We recommend ${riskProfile} fund like ${fundName}. ${stmt2}</p>
      //               </div>
      //             </div>
      //             <div>
      //             <span class="fs-5 fw-bold text-success">OUR PHILOSOPHY</span>
      //             <ul class="small mt-2 ms-3 text-justify text-dark">
      //                     ${[
      //     fund.philosophy1,
      //     fund.philosophy2,
      //     fund.philosophy3,
      //     fund.philosophy4,
      //     fund.philosophy5,
      //   ]
      //     .map((r) => `<li>${r}</li>`)
      //     .join("")}
      //                   </ul>
      //             </div>
      //           </div>
      //         `;

      const performanceCharacters = [
        fund.performance_character_1,
        fund.performance_character_2,
        fund.performance_character_3,
        fund.performance_character_4,
        fund.performance_character_5,
      ].filter(Boolean)

      const investmentApproach = [
        fund.investment_approach_1,
        fund.investment_approach_2,
        fund.investment_approach_3,
        fund.investment_approach_4,
        fund.investment_approach_5,
      ].filter(Boolean)

      const investmentStylePoints = [
        fund.investment_style_point_1,
        fund.investment_style_point_2,
        fund.investment_style_point_3,
        fund.investment_style_point_4,
      ].filter(Boolean)

      const behaviouralProfile = fund.behavioural_profile
        ? fund.behavioural_profile
            .split('\n')
            .filter(item => item.trim() !== '')
        : []

      const html = `
      <div style="background: #f5f7f4; font-family: Arial, sans-serif;">

        <!-- HEADER -->
        <div style="
            background: linear-gradient(135deg, #0d4f38, #0f5d3f);
            color: white;
            padding: 0.70rem 0.70rem;
            position: relative;
          ">

          <div class="row">

            <!-- LEFT -->
            <div class="col-sm-6">
              <div style="
                  font-size: 1.8rem;
                  font-weight: 300;
                  line-height: 1.15;
                  margin-bottom: 8px;
                ">
                ${goalName} | <span style="font-size: 1.1rem;font-weight: 200;line-height: 1.15;margin-bottom: 8px;">Target Year ${(goalYear || currentYear)}</span>
              </div>

              <div style="
                  font-size: 1.5rem;
                  font-weight: 500;
                  margin-bottom: 8px;
                ">
                ${fund.fund_name}
              </div>

              <div style="
                  font-size: .9rem;
                  opacity: .9;
                ">
                Category: ${fund.Category}
              </div>
            </div>

            <!-- RIGHT -->
            <div class="col-sm-6">

              <div class="row">

                <div class="col-6 mb-3">
                  <div style="
                      font-size: .75rem;
                      opacity: .8;
                      margin-bottom: 3px;
                    ">
                    FUND SIZE
                  </div>

                  <div style="
                      font-size: 1.6rem;
                      font-weight: 700;
                      white-space: nowrap;
                      line-height: 1.1;
                    ">
                    ₹${fund.AUM}
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div style="
                      font-size: .75rem;
                      opacity: .8;
                      margin-bottom: 3px;
                    ">
                    RETURNS SINCE INCEPTION
                  </div>

                  <div style="
                      font-size: 1.6rem;
                      font-weight: 700;
                      line-height: 1.1;
                    ">
                    ${SIRtn}%
                  </div>
                </div>

                <div class="col-6">
                  <div style="
                      font-size: .75rem;
                      opacity: .8;
                      margin-bottom: 3px;
                    ">
                    RETURN REQUIRED FOR GOAL
                  </div>

                  <div style="
                      font-size: 1.6rem;
                      font-weight: 700;
                      line-height: 1.1;
                    ">
                    ${rtn2}
                  </div>
                </div>

                <div class="col-6">
                  <div style="
                      font-size: .75rem;
                      opacity: .8;
                      margin-bottom: 3px;
                    ">
                    INVESTMENT HORIZON
                  </div>

                  <div style="
                      font-size: 1.6rem;
                      font-weight: 700;
                      line-height: 1.1;
                    ">
                    ${fund.investment_horizon} +
                  </div>
                </div>

              </div>

            </div>

          </div>

        </div>

        <!-- OBJECTIVE SECTION -->
        <div style="
            background: #eef3ee;
            padding: 10px 14px;
            border-bottom: 1px solid #dce5dc;
          ">

          <div class="row align-items-center">

            <div class="col-sm-3" style="
                border-right: 1px solid #d5dfd5;
              ">

              <div style="
                  color: #5b7c63;
                  font-size: .75rem;
                  font-weight: 600;
                ">
                PORTFOLIO ALLOCATION
              </div>

              <div style="
                  font-size: 0.85rem;
                  color: #1d1d1d;
                ">
                ${fund.portfolio_allocation || '-'}
              </div>

            </div>

            <div class="col-sm-9">

              <div style="
                  color: #5b7c63;
                  font-size: .75rem;
                  font-weight: 600;
                  margin-bottom: 4px;
                ">
                OBJECTIVE
              </div>

              <div style="
                  font-size: .85rem;
                  color: #222;
                  line-height: 1.5;
                ">
                ${fund.objective || '-'}
              </div>

            </div>

          </div>

        </div>

        <!-- MAIN CONTENT -->
        <div class="container-fluid" style="padding: 9px;">

          <div class="row">

            <!-- LEFT COLUMN -->
            <div class="col-md-4" style="border-right: 1px solid #d8e1d8;">

              <!-- ASSET MANAGER -->
              <div style="margin-bottom: 24px;">

                <div style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 12px;
                  ">

                  <div style="
                      width: 10px;
                      height: 10px;
                      background: #2d8a58;
                      border-radius: 50%;
                    "></div>

                  <div style="
                      color: #456a53;
                      font-size: 0.93rem;
                      letter-spacing: .5px;
                      font-weight: 600;
                    ">
                    ASSET MANAGER PROFILE
                  </div>

                </div>

                <p style="
                    color: #2f4235;
                    font-size: .85rem;
                    line-height: 1.6;
                    text-align: justify;
                  ">
                  ${fund.asset_manager_profile || '-'}
                </p>

              </div>

              <!-- BEHAVIOURAL PROFILE -->
              <div>

                <div style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 12px;
                  ">

                  <div style="
                      width: 10px;
                      height: 10px;
                      background: #2d8a58;
                      border-radius: 50%;
                    "></div>

                  <div style="
                      color: #456a53;
                      font-size: 0.93rem;
                      letter-spacing: .5px;
                      font-weight: 600;
                    ">
                    BEHAVIOURAL PROFILE
                  </div>

                </div>

                <ul style="
                    padding-left: 18px;
                    color: #2f4235;
                    line-height: 1.6;
                    font-size: .82rem;
                  ">
                  ${behaviouralProfile
                    .map(
                      (item) => `
                        <li>${item}</li>
                      `
                    )
                    .join("")}
                </ul>

              </div>

            </div>

            <!-- CENTER + RIGHT CONTENT -->
            <div class="col-md-8">

              <!-- TOP ROW -->
              <div class="row">

                <!-- PERFORMANCE CHARACTER -->
                <div class="col-md-6">

                  <div style="margin-bottom: 24px;">

                    <div style="
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        margin-bottom: 14px;
                      ">

                      <div style="
                          width: 10px;
                          height: 10px;
                          background: #2d8a58;
                          border-radius: 50%;
                        "></div>

                      <div style="
                          color: #456a53;
                          font-size: 0.93rem;
                          letter-spacing: .5px;
                          font-weight: 600;
                        ">
                        PERFORMANCE CHARACTER
                      </div>

                    </div>

                    ${performanceCharacters
                      .map(
                        (item) => `
                  <div style="
                      border-left: 3px solid #8bc69c;
                      background: #edf5ee;
                      padding: 4px 6px;
                      margin-bottom: 6px;
                      color: #3b5241;
                      line-height: 1.5;
                      font-size: .77rem;
                    ">
                    ${item}
                  </div>
                `
                      )
                      .join("")}

                  </div>

                </div>

                <!-- INVESTMENT APPROACH -->
                <div class="col-md-6">

                  <div style="
                      display: flex;
                      align-items: center;
                      gap: 8px;
                      margin-bottom: 14px;
                    ">

                    <div style="
                        width: 10px;
                        height: 10px;
                        background: #2d8a58;
                        border-radius: 50%;
                      "></div>

                    <div style="
                        color: #456a53;
                        font-size: 0.93rem;
                        letter-spacing: .5px;
                        font-weight: 600;
                      ">
                      INVESTMENT APPROACH
                    </div>

                  </div>

                  ${investmentApproach
                    .map(
                      (item) => `
                        <div style="
                            border: 1px solid #bdd4c0;
                            background: #f5faf5;
                            padding: 6px;
                            margin-bottom: 6px;
                            color: #334b39;
                            line-height: 1.5;
                            font-size: .77rem;
                          ">
                          ${item}
                        </div>
                      `
                    )
                    .join("")}

                </div>

              </div>

              <!-- FULL WIDTH INVESTMENT STYLE -->
              <div style="margin-top: 5px;">

                <div style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 6px;
                  ">

                  <div style="
                      width: 7px;
                      height: 7px;
                      background: #2d8a58;
                      border-radius: 50%;
                    "></div>

                  <div style="
                      color: #456a53;
                      font-size: 1rem;
                      letter-spacing: .5px;
                      font-weight: 600;
                    ">
                    INVESTMENT STYLE
                  </div>

                </div>

                <div style="
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 10px;
                    width: 100%;
                  ">

                  ${investmentStylePoints
                    .map(
                      (item, index) => `
                        <div style="
                            border: 1px solid #cddfcf;
                            background: #f7fbf7;
                            padding: 7px;
                            min-height: 90px;
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-start;
                            width: 100%;
                          ">

                          <div style="
                              color: #aed0b5;
                              font-size: 1.5rem;
                              font-weight: 700;
                              margin-bottom: 5px;
                              line-height: 1;
                            ">
                            0${index + 1}
                          </div>

                          <div style="
                              color: #334d39;
                              line-height: 1.45;
                              font-size: .70rem;
                              flex-grow: 1;
                            ">
                            ${item}
                          </div>

                        </div>
                      `
                    )
                    .join("")}

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
      `;
      setModalContent(html);
    } catch (err) {
      console.error(err);
      setModalContent(
        `<p class="text-danger text-center mt-3">Something went wrong</p>`,
      );
    }
  };

  const renderTableRows = (data, level = 0) => {
    if (!data?.categories || data.categories.length === 0) {
      return (
        <tr>
          <td colSpan="8" className="text-center">
            No Data Found
          </td>
        </tr>
      );
    }

    return data.categories.map((category, catIndex) => {
      const mainKey = `${level}-${catIndex}`;

      //  Utility for calculating fromDate
      const getFromDate = (fundType, subType, InvestedSince) => {
        let fromDate = moment(InvestedSince, ["DD/MM/YY", "DD/MM/YYYY"], true);
        // console.log('fromDate', fromDate, fundType, subType);
        return fromDate.format("YYYY-MM-DD");
        if (!fromDate.isValid()) {
          fromDate = moment();
        }

        // 🧮 Adjust based on fund type
        if (
          (fundType === "Equity" && subType !== "Equity - ELSS") ||
          (fundType === "Hybrid" && subType !== "Hybrid - Arbitrage")
        ) {
          fromDate.subtract(1, "year"); // -12 months
          // console.log('fromDate1', fromDate);
        } else if (
          fundType === "Debt" ||
          fundType === "Hybrid - Arbitrage" ||
          fundType === "Others"
        ) {
        } else {
          fromDate.subtract(3, "year"); // -36 months
        }
        return fromDate.format("YYYY-MM-DD");
      };

      return (
        <React.Fragment key={mainKey}>
          {/* <tr  className="border-bottom">
            <td className="" colSpan={8}>
              {data.username}
            </td>
          </tr> */}
          {/* ===== Category Row ===== */}
          <tr onClick={() => toggleRow(mainKey)} className="border-bottom">
            <td className="fs-14 trbgcolor fw-bold">
              <p className="m-1">{category.category}</p>
            </td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">
              {formatRupees(category.totalInvCost)}
            </td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">
              {formatRupees(category.totalMarketValue)}
            </td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">
              {formatRupees(category.totalGainLoss)}
            </td>
            {/* <td className="fs-14 fw-normal align-middle trbgcolor text-end">{calculateTotalFloat(category.xirr).toFixed(2)}%</td> */}
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">
              -
            </td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">
              {calculateTotalFloat(category.absReturn).toFixed(2)}%
            </td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">
              -
            </td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-end">
              -
            </td>
            <td className="fs-14 fw-normal align-middle trbgcolor text-center">
              -
            </td>
          </tr>

          {/* ===== Funds under this category ===== */}
          {category.funds?.map((fund, fundIndex) => {
            const subKey = `${mainKey}-fund-${fundIndex}`;
            const subRowFolio = fund?.FolioNumber || "";
            const subRowISIN = fund?.ISIN || "";

            const fundIdstx = fund?.FundID || "";
            const folioIdstx = fund?.FolioID || "";

            // console.log('fund89', fund.FundName, subRowFolio, subRowISIN)

            const goalName =
              getGoalDetail(subRowFolio, subRowISIN)?.goalName || "Unmapped";
            const clientreviewedfolioData = getClientreviewedfolio(
              subRowFolio,
              subRowISIN,
            );

            // const goalDetails = getGoalDetail(subRowFolio, subRowISIN);
            // console.log('clientreviewedfolioData99', clientreviewedfolioData.recommended_action);

            const effiBal = calculateEffectiveBalance(
              fund?.transactions,
              fund?.FundType,
              fund?.Sub_Category,
            );
            // console.log('category', effiBal, fund);

            const rowKey = `${subRowFolio}_${subRowISIN}`;
            const actionHTML =
              rowActions[rowKey] ||
              clientreviewedfolioData?.recommended_action ||
              "";
            console.log('actionHTML', rowKey, actionHTML);

            // This finds the folio match across ALL categories (Hybrid, Equity, etc.)
            const allSameFunds = data?.categories
              .flatMap(cat => cat.funds)
              .filter(f => f.FolioNumber === fund.FolioNumber);
            // const funds = categories ? category?.funds;
            // const allSameFunds = funds ? funds.filter(f => f.FolioNumber === fund.FolioNumber) : [];
            // const allFunds = allSameFunds?.map(f=>({folio:f.FolioNumber, isin:f.ISIN, fundName:f.FundName})) || [];
            console.log('allSameFunds', allSameFunds, category?.funds, fund);

            return (
              <React.Fragment key={subKey}>
                <tr className="border-bottom">
                  <td
                    style={{ paddingLeft: `${(level + 1) * 10}px` }}
                    className="fs-14 py-3 fw-normal align-middle"
                  >
                    <span className="fs-12">
                      {fund.FundName || "No Sub Name"} &nbsp;
                      {/* {isAllowedreview && isPrst === "Draft" && (
                        <FaEdit
                          onClick={() => handleEditClick(subRowFolio, subRowISIN, fund)}
                          className="text-success fs-6"
                        />
                      )} */}
                      {allowedReview && (
                        <FaEdit
                          onClick={() => {
                            handleEditClick(subRowFolio, subRowISIN, fund, allSameFunds);
                          }}
                          className="text-success fs-6"
                          style={{ cursor: "pointer" }}
                          title="Edit"
                        />
                      )}
                      &nbsp;
                      <FaEye
                        onClick={(e) =>
                          handleEyeClick(fundIdstx, folioIdstx, subKey, e)
                        }
                        className="text-primary fs-6 ms-2"
                      />
                      <p className="fs-12 mb-0 fw-bold">
                        Start Date:{" "}
                        {getFromDate(
                          fund.FundType,
                          fund.Sub_Category,
                          fund.InvestedSince,
                        )}
                      </p>
                      <p>
                        {clientreviewedfolioData?.portfolio_type_sip === 1 &&
                          "(SIP)"}
                      </p>
                    </span>
                  </td>

                  <td className="fs-14 py-3 fw-normal align-middle text-end">
                    {formatRupees(fund.InvCost)}
                  </td>
                  <td className="fs-14 py-3 fw-normal align-middle text-end">
                    {/* {formatRupees(fund.MarketValue)} */}
                    {isChecked
                      ? formatRupees(effiBal)
                      : formatRupees(fund.MarketValue)}
                  </td>
                  <td className="fs-14 py-3 fw-normal align-middle text-end">
                    {formatRupees(fund.GainLoss)}
                  </td>
                  <td className="fs-14 py-3 fw-normal align-middle text-end">
                    {fund.CAGR}%
                  </td>
                  <td className="fs-14 py-3 fw-normal align-middle text-end">
                    {fund.AbsRtn}%
                  </td>
                  <td className="fs-14 py-3 fw-normal align-middle text-end">
                    {fund?.account_number || '--'}<br />

                    {fund?.ifsc_code || '--'}
                  </td>
                  <td className="fs-14 fw-normal align-middle text-end">
                    {goalName}
                  </td>
                  <td
                    className="fs-14 py-3 fw-normal align-middle text-center"
                    style={{ width: "5%" }}
                  >
                    {actionHTML ? (
                      <>
                        {/* <div
                          className="d-inline"
                          onClick={() => { fetchViewPrErrors(clientreviewedfolioData.pr_row_id) }}
                          dangerouslySetInnerHTML={{ __html: actionHTML }}
                        /> */}

                        {clientreviewedfolioData?.recommended_action
                          ? renderRecommendedAction(
                            actionHTML,
                            clientreviewedfolioData.pr_row_id,
                            fund
                          )
                          : "No Action required"}

                        {/* <span>
                          {clientreviewedfolioData?.action !== "none" && (
                            <IoInformationCircleOutline
                              className="ms-2"
                              onClick={() => showFundDetails(fund.FundName, goalName, goalDetails.goalYear, goalDetails.startYear, fund.ISIN)}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </span> */}
                      </>
                    ) : (
                      "No Action required"
                    )}
                    {/* {(() => {
                      console.log('rowActions',actionHTML,subRowFolio)
                      const rowKey = `${subRowFolio}_${subRowISIN}`;
                      const actionHTML =rowActions[rowKey] || getClientreviewedfolio(subRowFolio, subRowISIN)?.recommended_action ||"";
                      console.log('rowKey',subRowFolio,subRowISIN,actionHTML)
                      // const schemeCodeData = schemeCode[rowKey];
                      // const hasAction = actionHTML.trim() !== "";

                      return (
                        <>
                          {actionHTML ? (
                            <>
                            <div
                              onClick={() =>
                                setShowActionFormModal(true)
                              }
                              dangerouslySetInnerHTML={{
                                __html: actionHTML,
                              }}
                            />
                            
                            </>
                          ):"No Action required"}
                          </>
                          )
          })} */}
                  </td>
                </tr>

                {/* ==== Transactions for each Fund ==== */}
                {expandedRowKey === subKey && (
                  <tr>
                    <td colSpan="10" className="p-2 bg-light">
                      {loadingRowKey === subKey ? (
                        <div className="text-center py-2">
                          Loading transactions...
                        </div>
                      ) : folioData[subKey]?.transactions?.length ? (
                        <table className="table table-sm mb-0">
                          <thead>
                            <tr>
                              <th className="clrgreen-black">Txn Type</th>
                              <th className="clrgreen-black">Date</th>
                              <th className="clrgreen-black">Amount</th>
                              <th className="clrgreen-black">Price</th>
                              <th className="clrgreen-black">Units</th>
                            </tr>
                          </thead>
                          <tbody>
                            {folioData[subKey].transactions.map(
                              (txn, tIndex) => (
                                <tr key={tIndex}>
                                  <td className="fs-12">{txn.Description}</td>
                                  <td className="fs-12">
                                    {txn.TransactionDate}
                                  </td>
                                  <td className="fs-12">
                                    {txn.CreditAmount !== "0"
                                      ? Number(txn.CreditAmount)?.toFixed(0)
                                      : Number(txn.DebitAmount)?.toFixed(0)}
                                  </td>
                                  <td className="fs-12">
                                    {Number(txn.TradePrice)?.toFixed(2)}
                                  </td>
                                  <td className="fs-12">
                                    {txn.CreditUnits !== "0"
                                      ? Number(txn.CreditUnits)?.toFixed(2)
                                      : Number(txn.DebitUnits)?.toFixed(2)}
                                  </td>
                                </tr>
                              ),
                            )}
                          </tbody>
                          <tfoot>
                            <tr className=" bg-light fs-12">
                              <td colSpan="2 " className="fw-bold">
                                Total
                              </td>
                              <td>
                                {Number(
                                  folioData[subKey]?.transactionTotal
                                    ?.Purchases,
                                )?.toFixed(0) || "-"}
                                {/* {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                  ?.Purchases || "-"} */}
                              </td>
                              <td>
                                {/* {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                  ?.AvgCost || "-"} */}
                                {Number(
                                  folioData[subKey]?.transactionTotal?.AvgCost,
                                ) || "-"}
                              </td>
                              <td>
                                {Number(
                                  folioData[subKey]?.transactionTotal
                                    ?.UnitsHeld,
                                )?.toFixed(2) || "-"}
                                {/* {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                  ?.UnitsHeld || "-"} */}
                              </td>
                            </tr>
                          </tfoot>
                          {/* <tfoot>
                            <tr className="fw-bold bg-light">
                              <td colSpan="2">Total</td>
                              <td>
                                {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                  ?.Purchases || "-"}
                              </td>
                              <td>
                                {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                  ?.AvgCost || "-"}
                              </td>
                              <td>
                                {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                  ?.UnitsHeld || "-"}
                              </td>
                            </tr>
                          </tfoot> */}
                        </table>
                      ) : (
                        <div className="text-center py-2">
                          No transactions found.
                        </div>
                      )}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </React.Fragment>
      );
    });
  };

  const [openItems, setOpenItems] = useState({});

  // Function to toggle a specific scheme
  const toggleItem = (index) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the specific index
    }));
  };

  // console.log('userData', userData);

  return (
    <>
      {/* <div className="scroll-container d-none d-md-block"> */}
      <table className="table align-middle mb-0 d-none d-md-table  ">
        <caption className="fw-bold txt-color p-2 mt-2">
          {userData?.username || ""}
        </caption>

        <colgroup>
          <col style={{ width: "15%" }} />
          <col style={{ width: "8%" }} />
          <col style={{ width: "12%" }} />
          <col style={{ width: "8%" }} />
          <col style={{ width: "8%" }} />
          <col style={{ width: "8%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "16%" }} />
        </colgroup>
        <thead className="sticky-header">
          <tr className="">
            <th scope="col" className="back-clrgreen txt-color-revers">
              Fund Name
            </th>

            <th scope="col" className="back-clrgreen txt-color-revers text-end">
              Inv Cost
            </th>

            <th scope="col" className="back-clrgreen txt-color-revers text-end">
              {isChecked ? "Load Free Unit" : "Current Value"}

              {/* <div className="d-flex align-items-center justify-content-center gap-2">
                <span className="text-nowrap">
                  {isChecked ? "Load Free Unit" : "Current Value"}
                </span> */}

              {/* {onlyone === "yes" && (
                  <div className="form-check form-switch m-0 toggle-color">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="valueToggle"
                      checked={isChecked}
                      onChange={handleToggle}
                      aria-label="Toggle between Current Value and Load Free Unit"
                    />
                  </div>
                )} */}
              {/* </div> */}
            </th>

            <th scope="col" className="back-clrgreen txt-color-revers text-end">
              Gain/Loss
            </th>
            <th scope="col" className="back-clrgreen txt-color-revers text-end">
              XIRR
            </th>
            <th
              scope="col"
              className="back-clrgreen txt-color-revers text-end text-nowrap"
            >
              Abs Rtn
            </th>
            <th
              scope="col"
              className="back-clrgreen txt-color-revers text-end text-nowrap"
            >
              Account
            </th>
            <th scope="col" className="back-clrgreen txt-color-revers text-end">
              Goal
            </th>
            <th
              scope="col"
              className="back-clrgreen txt-color-revers text-center"
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>{renderTableRows(userData)}</tbody>

        {userData?.categories?.length > 0 && (
          <>
            {/* ✅ Overall Total */}
            <tfoot>
              <tr>
                <th className="total-cell txt-color"> Total</th>
                <th className="total-cell text-end txt-color">
                  {/* {formatRupees(
            userData.categories.reduce((sum, cat) => sum + (Number(cat.totalInvCost )|| 0), 0)
          )} */}
                  {formatRupees(Number(userData?.userTotal?.totalInvCost))}
                </th>
                <th className="total-cell text-end txt-color">
                  {formatRupees(Number(userData?.userTotal?.totalMarketValue))}
                </th>
                <th className="total-cell text-end txt-color">
                  {formatRupees(Number(userData?.userTotal?.totalGainLoss))}
                </th>
                <th className="total-cell text-end txt-color">
                  {calculateTotalFloat(
                    Number(userData?.userTotal?.xirr).toFixed(2),
                  )}
                  %
                </th>
                <th className="total-cell text-end txt-color ">
                  {calculateTotalFloat(
                    Number(userData?.userTotal?.absReturn).toFixed(2),
                  )}
                  %
                </th>
                <th className="total-cell"></th>
                <th className="total-cell"></th>
                <th className="total-cell"></th>

              </tr>
            </tfoot>
          </>
        )}
      </table>
      {/* </div> */}

      {/* Mobile table */}

      <div className="d-block d-md-none">
        {userData?.categories?.map((category, catIdx) => (
          <div key={catIdx} className="mb-3">
            {/* Category Header start */}
            {/* <h6 className="fw-bold text-success mb-2">{category.category}</h6> */}
            <div className="row my-2 d-block d-md-none">
              <div className=" border-color-green px-3 rounded-3 clrgreenlight">
                {/* <div className="d-flex justify-content-between my-3  ">
                  <strong>{category.category}</strong>

                </div> */}
                <div className="d-flex justify-content-between my-3  ">
                  <span>Particular</span>
                  <span className="text-color-green">{category.category}</span>
                </div>
                <div className="d-flex justify-content-between my-3  ">
                  <span>Inv Cost</span>
                  <span className="text-color-green">
                    {formatRupees(category?.totalInvCost)}
                  </span>
                </div>
                <div className="d-flex justify-content-between my-3  ">
                  <span>Current Val</span>
                  <span className="text-color-green">
                    {formatRupees(category?.totalMarketValue)}
                  </span>
                </div>
                <div className="d-flex justify-content-between my-3  ">
                  <span>Gain/Loss</span>
                  <span className="text-color-green">
                    {formatRupees(category?.totalGainLoss)}
                  </span>
                </div>
                {/* <div className="d-flex justify-content-between my-3  ">
                  <span>XIRR</span>
                  <span className="text-color-green">
                    {calculateTotalFloat(grandTotal?.xirr).toFixed(2)}%
                  </span>
                </div> */}
                <div className="d-flex justify-content-between my-3  ">
                  <span>Abs Return</span>
                  <span className="text-color-green">
                    {calculateTotalFloat(category?.absReturn).toFixed(2)}%
                  </span>
                </div>
              </div>
            </div>
            {/* Category Header start end */}

            {/* Funds List */}
            {category.funds?.map((fund, fundIdx, level = 0) => {
              const mainKey = `${level}-${catIdx}`;

              const fundKey = `${catIdx}-${fundIdx}`;
              const isOpen = openFunds[fundKey] || false;
              const subRowFolio = fund?.FolioNumber || "";
              const subRowISIN = fund?.ISIN || "";
              const goalName =
                getGoalDetail(subRowFolio, subRowISIN)?.goalName || "Unmapped";

              const clientreviewedfolioData = getClientreviewedfolio(
                subRowFolio,
                subRowISIN,
              );
              const effiBal = calculateEffectiveBalance(
                fund?.transactions,
                fund?.FundType,
                fund?.Sub_Category,
              );
              // console.log('category', effiBal, fund);

              const rowKey = `${subRowFolio}_${subRowISIN}`;
              const actionHTML =
                rowActions[rowKey] ||
                clientreviewedfolioData?.recommended_action ||
                "";
              const subKey = `${mainKey}-fund-${fundIdx}`;
              const fundIdstx = fund?.FundID || "";
              const folioIdstx = fund?.FolioID || "";
              // console.log('actionHTML mobile', rowKey, actionHTML);

              return (
                <div key={fundKey} className="card shadow-sm border mb-2">
                  {/* Card Header */}
                  <div
                    className="card-header d-flex justify-content-between align-items-center bg-white"
                    onClick={() => toggleFund(fundKey)}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="fw-semibold text-truncate">
                      {fund.FundName}
                    </span>
                    {isOpen ? (
                      <FaMinus className="text-danger" />
                    ) : (
                      <FaPlus className="text-success" />
                    )}
                  </div>

                  {/* Card Body (expand on click) */}
                  {isOpen && (
                    <div className="card-body p-2">
                      {[
                        ["Investment Cost", formatRupees(fund.InvCost)],
                        ["Current Value", formatRupees(fund.MarketValue)],
                        ["Gain/Loss", formatRupees(fund.GainLoss)],
                        ["XIRR", `${fund.CAGR}%`],
                        ["Absolute Return", `${fund.AbsRtn}%`],
                        ["Account", `${fund.account_number}/${fund.ifsc_code}`],
                        ["Goal", `${goalName}`],
                        ["Action", `${actionHTML}}`],
                      ].map(([label, value], idx) => (
                        <div
                          key={idx}
                          className="d-flex justify-content-between border-bottom py-1"
                        >
                          <span className="fw-bold text-muted small">
                            {label}
                          </span>

                          {/* ✅ Conditionally render Action with HTML + click handler */}
                          {label === "Action" ? (
                            actionHTML ? (
                              <span
                                className="small cursor-pointer text-end"
                                onClick={() =>
                                  fetchViewPrErrors(
                                    clientreviewedfolioData.pr_row_id,
                                  )
                                }
                                dangerouslySetInnerHTML={{ __html: actionHTML }}
                              />
                            ) : (
                              <span className="small text-muted">N/A</span>
                            )
                          ) : (
                            <span className="small">{value}</span>
                          )}
                        </div>
                      ))}

                      {/* ✅ Transactions Row with Plus/Minus */}
                      <div
                        className="d-flex justify-content-between border-bottom py-1"
                        // onClick={() => toggleTransaction(fundKey)}
                        onClick={(e) =>
                          handleEyeClick(fundIdstx, folioIdstx, subKey, e)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <span className="fw-bold text-muted small">
                          Transactions
                        </span>
                        {expandedRowKey === subKey ? (
                          <FaMinus className="text-danger small" />
                        ) : (
                          <FaPlus className="text-success small" />
                        )}
                      </div>

                      {/* ✅ Transactions Table (expand on click) */}
                      {expandedRowKey === subKey && (
                        <>
                          {/* <table className="table table-bordered table-sm">
                            <thead>
                              <tr className="table-light">
                                <th>Type</th>
                                <th>Date</th>
                                <th className="text-end">Investment</th>
                                <th className="text-end">Current</th>
                                <th className="text-end">Gain/Loss</th>
                                <th className="text-end text-nowrap">Abs Rtn</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Array.isArray(fund.transactions) && fund.transactions.length > 0 ? (
                                fund.transactions.map((tx, txIdx) => (
                                  <tr key={txIdx}>
                                    <td>{tx?.Description || "N/A"}</td>
                                    <td>{tx?.TransactionDate || "N/A"}</td>
                                    <td className="text-end">{formatRupees(tx?.inv_amount || 0)}</td>
                                    <td className="text-end">{formatRupees(tx?.curr_val || 0)}</td>
                                    <td className="text-end">{formatRupees(tx?.gain_loss || 0)}</td>
                                    <td className="text-end">
                                      {tx?.abs_return ? tx.abs_return.toFixed(2) : "N/A"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="6" className="text-center">
                                    No Transactions Available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table> */}
                          {/* <tr> */}
                          <div className="table-responsive mt-2">
                            {loadingRowKey === subKey ? (
                              <div className="text-center py-2">
                                Loading transactions...
                              </div>
                            ) : folioData[subKey]?.transactions?.length ? (
                              <table className="table table-sm mb-0">
                                <thead>
                                  <tr>
                                    <th>Txn Type</th>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th>Price</th>
                                    <th>Units</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {folioData[subKey].transactions.map(
                                    (txn, tIndex) => (
                                      <tr key={tIndex}>
                                        <td className="fs-12">
                                          {txn.Description}
                                        </td>
                                        <td className="fs-12">
                                          {txn.TransactionDate}
                                        </td>
                                        <td className="fs-12">
                                          {txn.CreditAmount !== "0"
                                            ? Number(txn.CreditAmount)?.toFixed(
                                              0,
                                            )
                                            : Number(txn.DebitAmount)?.toFixed(
                                              0,
                                            )}
                                        </td>
                                        <td className="fs-12">
                                          {Number(txn.TradePrice)?.toFixed(2)}
                                        </td>
                                        <td className="fs-12">
                                          {txn.CreditUnits !== "0"
                                            ? Number(txn.CreditUnits)?.toFixed(
                                              2,
                                            )
                                            : Number(txn.DebitUnits)?.toFixed(
                                              2,
                                            )}
                                        </td>
                                      </tr>
                                    ),
                                  )}
                                </tbody>
                                <tfoot>
                                  <tr className=" bg-light fs-12">
                                    <td colSpan="2 " className="fw-bold">
                                      Total
                                    </td>
                                    <td>
                                      {Number(
                                        folioData[subKey]?.transactionTotal
                                          ?.Purchases,
                                      )?.toFixed(0) || "-"}
                                      {/* {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                  ?.Purchases || "-"} */}
                                    </td>
                                    <td>
                                      {/* {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                  ?.AvgCost || "-"} */}
                                      {Number(
                                        folioData[subKey]?.transactionTotal
                                          ?.AvgCost,
                                      ) || "-"}
                                    </td>
                                    <td>
                                      {Number(
                                        folioData[subKey]?.transactionTotal
                                          ?.UnitsHeld,
                                      )?.toFixed(2) || "-"}
                                      {/* {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                  ?.UnitsHeld || "-"} */}
                                    </td>
                                  </tr>
                                </tfoot>
                                {/* <tfoot>
                                  <tr className="fw-bold bg-light">
                                    <td colSpan="2">Total</td>
                                    <td>
                                      {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                        ?.Purchases || "-"}
                                    </td>
                                    <td>
                                      {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                        ?.AvgCost || "-"}
                                    </td>
                                    <td>
                                      {folioData[`${fundIdstx}_${folioIdstx}`]?.transactionTotal
                                        ?.UnitsHeld || "-"}
                                    </td>
                                  </tr>
                                </tfoot> */}
                              </table>
                            ) : (
                              <div className="text-center py-2">
                                No transactions found.
                              </div>
                            )}
                          </div>
                          {/* </tr> */}
                        </>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      <FundEditModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        roomId={roomId}
        isPortfolioData={isPortfolioData}
        editRowData={editRowData}
        openSipFormAllData={openSipFormAllData}
        rowKey={currentRowKey}
        onActionUpdate={(rowKey, updatedHtml, scheme_code) => {
          // console.log('here454',updatedHtml,scheme_code)
          setRowActions((prev) => ({
            ...prev,
            [rowKey]: updatedHtml,
          }));
          setSchemeCode((prev) => ({
            ...prev,
            [rowKey]: scheme_code,
          }));
        }}
        getClientreviewedfolio={getClientreviewedfolio}
        fetchPortfolioData={fetchPortfolioData}
        setIsActionMessage={setIsActionMessage}
        amcName={amcName}
      // setAmcFundList={setAmcFundList}
      // defaultValues={defaultData}
      />

      <ActionFormModal
        show={showActionFormModal}
        content={"No Form created"}
        onHide={() => {
          setShowActionFormModal(false);
          setViewPrErrors([]);
        }}
        roomId={roomId}
        prRowId={prRowId}
        viewPrErrors={viewPrErrors}
        setViewPrErrors={setViewPrErrors}
        fetchViewPrErrors={fetchViewPrErrors}
      />

      {/* <ActionFormModal
            show={showActionFormModal}
            content={"No Form created"}
        onHide={() => { setShowActionFormModal(false); setViewPrErrors([])}}
            roomId={roomId}
        prRowId={prRowId}
        viewPrErrors={viewPrErrors} setViewPrErrors={setViewPrErrors}
          /> */}

      <FundDetailsModal
        show={showActionModal}
        onHide={() => setShowActionModal(false)}
        content={modalContent}
      />

      <div className="d-block d-md-none">
        {userData?.[0] && (
          <div className="border border-1 rounded-3 p-3 mb-3 bg-white shadow-sm">
            {/* Header */}
            <div
              className="d-flex justify-content-between align-items-center mb-3"
              onClick={() => toggleItem(userData[0]?.Name)}
              style={{ cursor: "pointer" }}
            >
              <h5 className="fs-16 fw-bold m-0 d-flex align-items-center justify-content-between gap-2">
                <span>{userData[0]?.Name}</span>
              </h5>
              <span>
                {openItems[userData[0]?.Name] ? (
                  <FaMinus className="text-danger" />
                ) : (
                  <FaPlus className="text-success" />
                )}
              </span>
            </div>
          </div>
        )}

        <FundDetailsModal
          show={showModal}
          onHide={() => setShowModal(false)}
          content={modalContent}
        />
      </div>
    </>
  );
}
